import { render } from "./add_role_modal.vue?vue&type=template&id=b85cab4a&scoped=true"
import script from "./add_role_modal.vue?vue&type=script&lang=js"
export * from "./add_role_modal.vue?vue&type=script&lang=js"

import "./add_role_modal.vue?vue&type=style&index=0&id=b85cab4a&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b85cab4a"]])

export default __exports__